// ===== Mueblika · "Deja tu reseña" (enlace + pop-up) =====

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    initModal();
    initForm();
  });

  /* ---------- Abrir / cerrar el pop-up ---------- */
  function initModal() {
    const modal = document.querySelector('[data-mbk-write-review-modal]');
    const openBtn = document.querySelector('[data-mbk-write-review-open]');
    const closeBtns = document.querySelectorAll('[data-mbk-write-review-close]');
    if (!modal || !openBtn) return;

    function getFocusable() {
      return Array.from(
        modal.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), textarea:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])')
      ).filter((el) => el.offsetParent !== null);
    }

    function open() {
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      // Foco al primer elemento del modal, en vez de dejarlo flotando
      // en el botón que ya ha quedado tapado por el propio pop-up.
      const focusable = getFocusable();
      if (focusable.length) focusable[0].focus();
    }

    function close() {
      modal.hidden = true;
      document.body.style.overflow = '';
      // Devolver el foco a quien abrió el pop-up, para no dejarlo
      // "perdido" en un elemento que ya no se ve.
      openBtn.focus();
    }

    openBtn.addEventListener('click', open);
    closeBtns.forEach((btn) => btn.addEventListener('click', close));

    document.addEventListener('keydown', function (e) {
      if (modal.hidden) return;
      if (e.key === 'Escape') {
        close();
        return;
      }
      // Atrapar el foco dentro del modal mientras está abierto: al
      // llegar al final con Tab, vuelve al principio (y viceversa con
      // Mayús+Tab), para que no se escape al contenido de detrás.
      if (e.key === 'Tab') {
        const focusable = getFocusable();
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    });
  }

  /* ---------- El formulario en sí ---------- */
  function initForm() {
    const form = document.querySelector('[data-mbk-resena-form]');
    if (!form) return;

    const endpoint = form.dataset.endpoint;
    const errorMsg = document.querySelector('[data-mbk-resena-error]');
    const submitBtn = form.querySelector('.mbk-resena-form__submit');
    const turnstileInput = form.querySelector('[data-mbk-resena-turnstile]');
    const privacidadInput = form.querySelector('input[name="acepta_privacidad"]');

    const viewForm = document.querySelector('[data-mbk-resena-view-form]');
    const viewThanks = document.querySelector('[data-mbk-resena-view-thanks]');

    // ---------- Selector de estrellas ----------
    const stars = form.querySelectorAll('.mbk-resena-form__star');
    const valoracionInput = form.querySelector('[data-mbk-resena-valoracion]');

    function setStars(value) {
      stars.forEach((star) => {
        star.classList.toggle('is-active', parseInt(star.dataset.value, 10) <= value);
      });
      valoracionInput.value = value;
    }

    setStars(5);

    stars.forEach((star) => {
      star.addEventListener('click', () => setStars(parseInt(star.dataset.value, 10)));
    });

    // ---------- Foto (opcional) ----------
    const fotoInput = form.querySelector('[data-mbk-resena-foto]');
    const fotoHint = form.querySelector('[data-mbk-resena-foto-hint]');
    const fotoHintTextoOriginal = fotoHint ? fotoHint.textContent : '';
    const MAX_FOTO_BYTES = 8 * 1024 * 1024;

    if (fotoInput) {
      fotoInput.addEventListener('change', function () {
        const file = fotoInput.files[0];
        if (!file) {
          if (fotoHint) {
            fotoHint.textContent = fotoHintTextoOriginal;
            fotoHint.removeAttribute('data-state');
          }
          return;
        }
        if (file.size > MAX_FOTO_BYTES) {
          if (fotoHint) {
            fotoHint.textContent = 'Esa foto pesa demasiado (máximo 8 MB). Elige otra, por favor.';
            fotoHint.setAttribute('data-state', 'error');
          }
          fotoInput.value = '';
          return;
        }
        if (fotoHint) {
          fotoHint.textContent = '✓ ' + file.name;
          fotoHint.setAttribute('data-state', 'ok');
        }
      });
    }

    function leerFotoComoBase64(file) {
      return new Promise((resolve, reject) => {
        if (!file) {
          resolve(null);
          return;
        }
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    }

    function showError(text) {
      if (errorMsg) {
        errorMsg.textContent = text;
        errorMsg.hidden = false;
      }
    }

    function resetFormulario() {
      form.reset();
      setStars(5);
      if (fotoHint) {
        fotoHint.textContent = fotoHintTextoOriginal;
        fotoHint.removeAttribute('data-state');
      }
      if (window.turnstile) window.turnstile.reset();
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      if (errorMsg) errorMsg.hidden = true;

      if (privacidadInput && !privacidadInput.checked) {
        showError('Tienes que aceptar la Política de Privacidad para poder enviar tu reseña.');
        return;
      }

      if (!turnstileInput.value) {
        showError('Espera un momento a que se complete la verificación de seguridad, y vuelve a intentarlo.');
        return;
      }

      if (submitBtn) submitBtn.disabled = true;

      const fotoFile = fotoInput ? fotoInput.files[0] : null;
      const uploadingMsg = document.querySelector('[data-mbk-resena-uploading]');
      if (fotoFile && uploadingMsg) uploadingMsg.hidden = false;

      leerFotoComoBase64(fotoFile)
        .then((fotoBase64) => {
          const payload = {
            nombre: form.querySelector('#resena-nombre').value,
            valoracion: valoracionInput.value,
            producto: form.querySelector('#resena-producto').value,
            texto: form.querySelector('#resena-texto').value,
            categoria: 'Reseñas',
            turnstileToken: turnstileInput.value,
          };

          if (fotoBase64) {
            payload.foto_base64 = fotoBase64;
            payload.foto_nombre = fotoFile.name;
          }

          return fetch(endpoint, {
            method: 'POST',
            body: JSON.stringify(payload),
          });
        })
        .then((res) => res.json())
        .then((data) => {
          if (data && data.result === 'error') {
            throw new Error(data.message || 'No se pudo verificar el formulario');
          }
          // Cambia a la vista de agradecimiento, dentro del mismo pop-up
          if (viewForm) viewForm.hidden = true;
          if (viewThanks) viewThanks.hidden = false;
          resetFormulario();
        })
        .catch((err) => {
          showError(err.message || 'Ha ocurrido un error al enviar tu reseña. Inténtalo de nuevo.');
          if (window.turnstile) window.turnstile.reset();
        })
        .finally(() => {
          if (submitBtn) submitBtn.disabled = false;
          if (uploadingMsg) uploadingMsg.hidden = true;
        });
    });

    // Al cerrar el pop-up tras el agradecimiento, vuelve a mostrar el
    // formulario vacío la próxima vez que se abra
    const modal = document.querySelector('[data-mbk-write-review-modal]');
    if (modal) {
      document.querySelectorAll('[data-mbk-write-review-close]').forEach((btn) => {
        btn.addEventListener('click', () => {
          setTimeout(() => {
            if (viewThanks && !viewThanks.hidden) {
              viewThanks.hidden = true;
              if (viewForm) viewForm.hidden = false;
            }
          }, 300);
        });
      });
    }
  }
})();